import script from "./introCharacterSection.vue?vue&type=script&setup=true&lang=js"
export * from "./introCharacterSection.vue?vue&type=script&setup=true&lang=js"

import "./introCharacterSection.vue?vue&type=style&index=0&id=0fa5f89d&lang=css"

const __exports__ = script;

export default __exports__